<template lang="pug">
  v-row 
      v-col(cols="12")
        v-card.rounded-lg.pa-4(flat)

          v-card-title {{$t('config.social.title')}}
            v-chip.ma-2(outlined x-small dense color="primary") Beta
          v-card-subtitle 
            | {{$t('config.social.subtitle')}} 
            a.text-decoration-underline(target="_top" href="mailto:support@simplymotion.de?subject=Netzwerk anfragen") {{$t('config.social.requestSocial')}}
          v-card-text.my-6
            v-row.px-0.socialElements
              v-col.pb-8(cols="12" sm="6" md="3" v-if="hasFeatureAccess(RestrictedFeature.SOCIAL_CONNECTION_YOUTUBE)")
                v-card.rounded-lg( height="100%" style="position: relative" )
                  v-card-text.text-center
                    v-avatar(size="90")
                      v-img(src="@/assets/img/social/simplymotion-youtube.png")
                    

                    v-card-title.justify-center.text-center {{$t("social.platforms.YOUTUBE.label")}}
                    
                    v-card-subtitle.mb-4.text-center(v-if="isConnected(youTubeConnection)") {{$t('config.social.connected')}}
                    .checkIcon(v-if="isConnected(youTubeConnection)")
                      v-avatar(color="white" size="40" )
                        v-icon(small color="#e02f2f") fas fa-check
                    
                    v-card-actions(v-if="!isConnected(youTubeConnection)")
                      //-v-btn.text-normal(block text color="#e02f2f" @click="setupConnection(youTubeConnection, SocialConnectionPlatform.YOUTUBE)") 
                        | {{$t('config.social.addBtn', {social: "YouTube"})}}
                      v-img.pointer(src="@/assets/img/btn_google_signin_light_normal_web.png" @click="setupConnection(youTubeConnection, SocialConnectionPlatform.YOUTUBE)")
                        

                 

              v-col.pb-8(cols="12" sm="6" md="3" v-if="!hasFeatureAccess(RestrictedFeature.SOCIAL_CONNECTION_YOUTUBE)")
                v-card.rounded-lg(disabled height="100%")
                  v-card-text.text-center
                    v-avatar(size="90")
                      v-img(src="@/assets/img/social/simplymotion-youtube.png")
                  v-card-title.justify-center.text-center YouTube
                  v-card-subtitle.text-center coming soon
              v-col.pb-8(cols="12" sm="6" md="3")
                v-card.rounded-lg(disabled height="100%")
                  v-card-text.text-center
                    v-avatar(size="90")
                      v-img(src="@/assets/img/social/simplymotion-vimeo.png")
                  v-card-title.justify-center.text-center Vimeo
                  v-card-subtitle.text-center coming soon
                  //-v-card-actions
                    v-btn.text-normal(block text color="#03bcfc" @click="connectYoutube") {{$t('config.social.addBtn', {social: "Vimeo"})}}
              v-col.pb-8(cols="12" sm="6" md="3")
                v-card.rounded-lg(disabled height="100%")
                  v-card-text.text-center
                    v-avatar(size="90")
                      v-img(src="@/assets/img/social/simplymotion-linkedin.png")
                  v-card-title.justify-center.text-center LinkedIn
                  v-card-subtitle.text-center coming soon
                  //-v-card-actions
                    v-btn.text-normal(block text color="#0175b3" @click="connectYoutube") {{$t('config.social.addBtn', {social: "LinkedIn"})}}
              v-col.pb-8(cols="12" sm="6" md="3")
                v-card.rounded-lg(disabled height="100%")
                  v-card-text.text-center
                    v-avatar(size="90")
                      v-img(src="@/assets/img/social/simplymotion-instagram.png")
                  v-card-title.justify-center.text-center Instagram
                  v-card-subtitle.text-center coming soon
                  //-v-card-actions
                    v-btn.text-normal(block text color="#d2296a" @click="connectYoutube") {{$t('config.social.addBtn', {social: "Instagram"})}}

            //-v-list(subheader='' two-line='')
              v-list-item
                v-list-item-content
                  v-card-title YouTube
                v-list-item-action.mt-0
                  v-btn.mt-0(@click="connectYoutube" depressed color="primary") 
                    | YouTube anbinden
                    v-icon(right) mdi-chevron-right
            
</template>

<script>
import { OAuth2 } from "@/services/oauth2";
import { mapState } from "vuex";
import { SocialConnectionPlatform, RestrictedFeature } from "@/models";
import { SocialConnectionStatus } from "@/models";
import { hasFeatureAccess } from "@/utils/featureAccess";
export default {
  name: "social-settings",

  data() {
    return { SocialConnectionPlatform, RestrictedFeature };
  },
  computed: {
    ...mapState({
      socialConnections: (state) => state.settings.socialConnections,
    }),
    youTubeConnection() {
      return this.socialConnections.find(
        (connection) => connection.platform === SocialConnectionPlatform.YOUTUBE
      );
    },
  },
  methods: {
    hasFeatureAccess,
    async setupConnection(socialConnection, platform) {
      if (!socialConnection) {
        socialConnection = await this.$store.dispatch(
          "settings/CREATE_SOCIAL_CONNECTION",
          { platform }
        );
      }
      OAuth2().triggerOAuthFlow({ socialConnection });
    },
    isConnected(socialConnection) {
      return (
        socialConnection &&
        socialConnection.status === SocialConnectionStatus.CONNECTED
      );
    },
  },
  async mounted() {
    this.$store.dispatch("settings/FETCH_SOCIAL_CONNECTIONS");
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables'
.socialElements
  .v-card
    box-shadow: $box-shadow-dense
  .checkIcon
    position: absolute
    left: 0
    bottom: -20px
    right: 0
    display: flex
    justify-content: center
    .v-avatar
      box-shadow: $box-shadow
</style>
